
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"20","height":"20","viewBox":"0 0 20 20","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M19.4141 1.99219H10.8524C10.5982 1.99219 10.373 2.15605 10.2949 2.39789L9.66836 4.33594H0.585938C0.262344 4.33594 0 4.59828 0 4.92188C0 5.18602 0 17.0139 0 17.4219C0 17.7455 0.262344 18.0078 0.585938 18.0078H19.4141C19.7377 18.0078 20 17.7455 20 17.4219V2.57812C20 2.25453 19.7377 1.99219 19.4141 1.99219ZM1.17188 5.50781H9.28949L8.91066 6.67969H1.17188V5.50781ZM18.8281 16.8359H1.17188V7.85156H9.33703C9.59121 7.85156 9.81637 7.6877 9.89457 7.44586C10.0249 7.04277 11.1492 3.56484 11.2787 3.16406H18.8281V16.8359Z"}})])
          )
        }
      }
    